import { QueryFactory } from "../../../../Common";
import { Captor } from "../../../../Contracts";
export const QReport = QueryFactory(Captor.QueryTypes.Report);
//# sourceMappingURL=QReport.js.map